'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var RESOURCES_FETCHING = exports.RESOURCES_FETCHING = 'RESOURCES_FETCHING';
var RESOURCES_FETCHED = exports.RESOURCES_FETCHED = 'RESOURCES_FETCHED';
var RESOURCES_FETCH_ERROR = exports.RESOURCES_FETCH_ERROR = 'RESOURCES_FETCH_ERROR';
var RESOURCES_MARKED_AS_STALE = exports.RESOURCES_MARKED_AS_STALE = 'RESOURCES_MARKED_AS_STALE';
var RESOURCES_INVALIDATED = exports.RESOURCES_INVALIDATED = 'RESOURCES_INVALIDATED';

var RESOURCE_TYPES = exports.RESOURCE_TYPES = {
    elements: 'elements',
    boards: 'boards',
    users: 'users'
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/services/http/resources/resourceConstants.js
// module id = 85
// module chunks = 0